import { useConfig, type Mood } from '../store';

const MOODS: readonly { value: Mood; label: string }[] = [
  { value: 'tramonto', label: 'Tramonto' },
  { value: 'notte', label: 'Notte' },
];

function MoodIcon({ mood }: { mood: Mood }) {
  return mood === 'tramonto' ? (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" aria-hidden="true" className="size-[15px] shrink-0">
      <path d="M3.5 10.5a4.5 4.5 0 0 1 9 0" />
      <path d="M1.5 13h13" />
      <path d="M8 3v1.6M3.4 5.4l1.1 1.1M12.6 5.4l-1.1 1.1" />
    </svg>
  ) : (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" aria-hidden="true" className="size-[15px] shrink-0">
      <path d="M12.9 10.3A5.5 5.5 0 0 1 5.7 3.1a5.5 5.5 0 1 0 7.2 7.2Z" />
    </svg>
  );
}

export function MoodSwitch() {
  const mood = useConfig((s) => s.mood);
  const setMood = useConfig((s) => s.setMood);

  return (
    <div
      role="group"
      aria-label="Lighting"
      className="absolute right-3 top-3 grid grid-cols-2 rounded-full bg-[rgb(8_24_50/0.86)] p-[3px] shadow-[inset_0_0_0_1px_rgb(255_255_255/0.1),0_8px_24px_-12px_rgb(0_0_0/0.6)] wide:right-4 wide:top-3.5"
    >
      <span
        aria-hidden="true"
        className={`absolute inset-y-[3px] left-[3px] w-[calc(50%-3px)] rounded-full bg-white/10 shadow-[inset_0_1px_0_rgb(255_255_255/0.1)] transition-transform duration-[260ms] ease-[cubic-bezier(0.3,0.7,0.2,1)] motion-reduce:transition-none ${
          mood === 'notte' ? 'translate-x-full' : 'translate-x-0'
        }`}
      />
      {MOODS.map((m) => (
        <button
          key={m.value}
          type="button"
          aria-pressed={mood === m.value}
          onClick={() => setMood(m.value)}
          className={`mood-button relative inline-flex h-[30px] items-center justify-center gap-[7px] rounded-full pl-3 pr-3.5 text-[13px] leading-none tracking-[0.01em] transition-colors duration-200 motion-reduce:transition-none ${
            mood === m.value ? 'text-white' : 'text-white/55 hover:text-white/85'
          }`}
        >
          <span
            className={`inline-flex transition-colors duration-200 motion-reduce:transition-none ${
              mood !== m.value ? 'text-white/45' : m.value === 'tramonto' ? 'text-[#ffd2a0]' : 'text-[#9fb9e8]'
            }`}
          >
            <MoodIcon mood={m.value} />
          </span>
          {m.label}
        </button>
      ))}
    </div>
  );
}
